import { getTexts } from "../../../utils/texts";
var _getTexts = getTexts(),
  _getTexts$errorMessag = _getTexts.errorMessages,
  appPushDeclined = _getTexts$errorMessag.appPushDeclined,
  osPushDeclined = _getTexts$errorMessag.osPushDeclined,
  notificationSent = _getTexts.informationMessages.notificationSent;
export function getNotificationLabels(variant) {
  switch (variant) {
    case 'notification_sent':
      {
        return {
          title: notificationSent.title,
          footerTextPart_1: notificationSent.footerTextPart_1,
          footerResendLink: notificationSent.footerResendLink,
          footerTextPart_2: notificationSent.footerTextPart_2,
          footerLinkNavigation: notificationSent.footerLinkNavigation,
          dataTestId: 'notification_success_footer'
        };
      }
    case 'os_push_declined':
      {
        return {
          title: osPushDeclined.title,
          body: osPushDeclined.body,
          footerLinkNavigation: osPushDeclined.footerLinkNavigation,
          dataTestId: 'os_push_declined_footer'
        };
      }
    case 'app_push_declined':
      {
        return {
          title: appPushDeclined.title,
          footerTextPart_1: appPushDeclined.footerTextPart_1,
          dataTestId: 'app_push_declined_footer'
        };
      }
    default:
      return {
        title: '',
        footerTextPart_1: '',
        footerLinkNavigation: ''
      };
  }
}